import { render } from "./ElectronicCar.vue?vue&type=template&id=d4e9294a"
import script from "./ElectronicCar.vue?vue&type=script&lang=js"
export * from "./ElectronicCar.vue?vue&type=script&lang=js"

import exportComponent from "C:\\git\\js\\bible_finder_ui_vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__